import { useParams } from 'react-router-dom'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useTranslation } from 'react-i18next'
import {
    deleteTicketComment,
    getTicketComments,
    updateTicketComment,
} from '@/modules/Ticket/services'
import { Button, Dialog, FormItem, IconButton, Typogaphy } from 'vnetwork-ui'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import EditIcons from '@/icons/EditIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import useAuthStore from '@/stores/useAuthStore'
import { useConfirmation } from '@/contexts/confirmation'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface TicketCommentsListProps {
    refetchCurrent: () => void
}
const TicketCommentsList: React.FC<TicketCommentsListProps> = ({
    refetchCurrent,
}) => {
    const { ticketID } = useParams<{ ticketID: string }>()
    const { employee } = useAuthStore()
    const { t } = useTranslation()
    const { setConfirmation } = useConfirmation()
    const [selectedImage, setSelectedImage] = useState<string | null>(null)
    const [editingComment, setEditingComment] = useState<any | null>(null)
    const { control, handleSubmit, setValue } = useForm({
        defaultValues: { ticket_comment_text: '' },
    })
    const { data: ticketComment, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.TICKET_COMMENT, ticketID],
        queryFn: async () => {
            const result = await getTicketComments({
                ticket_id: Number(ticketID) || 0,
            })
            return result
        },
    })
    const { refetchAll: refetchLogs } = useDataGridRefetch({
        reactQueryKey: `ticket-logs-${ticketID}`,
    })
    const { mutateAsync: updateTicketCommentMutation, isPending } =
        useMutationWithHandler(
            { mutationFn: updateTicketComment },
            {
                reactQueryKeys: QUERY_KEYS.TICKETS,
                successMessage: t('updated-success'),
                onSuccess: () => {
                    refetchCurrent()
                    refetchLogs()
                    setEditingComment(null)
                },
            }
        )

    const { mutateAsync: deleteTicketCommentMutation } = useMutationWithHandler(
        { mutationFn: deleteTicketComment },
        {
            reactQueryKeys: QUERY_KEYS.TICKETS,
            successMessage: t('delete-success'),
            onSuccess: () => {
                refetchCurrent()
                refetchLogs()
                setEditingComment(null)
            },
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const handleEdit = (comment: any) => {
        setEditingComment({
            id: comment.ticket_comment_id,
            text: comment.ticket_comment_text,
        })
        setValue('ticket_comment_text', comment.ticket_comment_text)
    }
    const handleUpdateComment = async (data: any) => {
        if (!editingComment) return
        try {
            await updateTicketCommentMutation({
                ticket_comment_id: editingComment.id,
                ticket_comment_text: data.ticket_comment_text,
            })
        } catch (error) {
            console.error('Lỗi khi cập nhật bình luận:', error)
        }
    }

    const handleDeleteComment = async (commentId: number) => {
        try {
            await deleteTicketCommentMutation({
                ticket_comment_id: commentId,
            })
        } catch (error) {
            console.error('Lỗi khi xoá bình luận:', error)
        }
    }
    return (
        <div
            className={`${ticketComment?.results?.length ? 'bg-white border rounded-lg p-4' : ''}`}
        >
            {ticketComment?.results?.length ? (
                // <div className="space-y-4">
                //     {ticketComment.results.map((item, index) => {
                //         const markdownContent = item?.ticket_comment_text || ''
                //         const imgTagRegex = /!\[.*?\]\((https?:\/\/[^\s)]+)\)/g
                //         const matches = [
                //             ...markdownContent.matchAll(imgTagRegex),
                //         ]
                //         const imageUrls = matches.map((match) => match[1])
                //         const cleanedMarkdown = markdownContent
                //             .replace(imgTagRegex, '')
                //             .trim()

                //         return (
                //             <div key={index} className="p-3 border rounded-md">
                //                 <div className="text-sm text-gray-700 mb-1 flex items-center gap-1">
                //                     <IconButton size="medium">
                //                         <FaceIcons className="text-blue-600" />
                //                     </IconButton>
                //                     <Typogaphy
                //                         size="small"
                //                         className="text-blue-500"
                //                     >
                //                         {item?.employee_name ||
                //                             'Không xác định'}
                //                     </Typogaphy>
                //                     <span>added a process -</span>
                //                     <span>
                //                         {item?.updated_at
                //                             ? dayjs(item.updated_at).fromNow()
                //                             : 'N/A'}
                //                     </span>
                //                     <div className="flex gap-2 lg:ml-auto">
                //                         {employee?.employee_id ===
                //                             item?.employee_id && (
                //                             <>
                //                                 <IconButton
                //                                     size="medium"
                //                                     onClick={() =>
                //                                         handleEdit(item)
                //                                     }
                //                                 >
                //                                     <EditIcons className="text-blue-500" />
                //                                 </IconButton>
                //                                 <IconButton
                //                                     size="medium"
                //                                     onClick={() =>
                //                                         setConfirmation({
                //                                             title: t(
                //                                                 'ticket-comment-title'
                //                                             ),
                //                                             description: t(
                //                                                 'ticket-comment-description'
                //                                             ),
                //                                             onConfirm: () => {
                //                                                 console.log(
                //                                                     'Deleting comment with ID:',
                //                                                     item.ticket_comment_id
                //                                                 )
                //                                                 handleDeleteComment(
                //                                                     item.ticket_comment_id
                //                                                 )
                //                                             },
                //                                             open: true,
                //                                         })
                //                                     }
                //                                 >
                //                                     <DeleteOutlineIcons className="text-red-500" />
                //                                 </IconButton>
                //                             </>
                //                         )}
                //                     </div>
                //                 </div>

                //                 {cleanedMarkdown && (
                //                     <Preview
                //                         content={cleanedMarkdown}
                //                         scrollElement={
                //                             document.querySelector(
                //                                 '.scroll-element'
                //                             ) as HTMLElement
                //                         }
                //                     />
                //                 )}
                //                 {imageUrls.length > 0 && (
                //                     <div className="mt-2 flex flex-wrap gap-2">
                //                         {imageUrls.map((url, index) => (
                //                             <img
                //                                 key={index}
                //                                 src={url}
                //                                 alt={`Attachment ${index + 1}`}
                //                                 className="w-24 h-24 object-cover rounded-md cursor-zoom-in transition duration-200 hover:scale-110"
                //                                 onClick={() =>
                //                                     setSelectedImage(url)
                //                                 }
                //                             />
                //                         ))}
                //                     </div>
                //                 )}
                //             </div>
                //         )
                //     })}
                // </div>
                <div className="space-y-4">
                    {ticketComment?.results?.map((item, index) => {
                        return (
                            <div key={index} className="p-3 border rounded-md">
                                <div className="flex items-center justify-between">
                                    <div className="flex flex-col">
                                        <div className="flex items-center gap-2">
                                            <Typogaphy
                                                size="small"
                                                className="font-semibold"
                                            >
                                                {item?.ticket_comment_author_type ===
                                                'customer'
                                                    ? 'Khách hàng'
                                                    : item?.employee_name || ''}
                                            </Typogaphy>
                                            {item?.ticket_comment_author_type ===
                                            'customer' ? (
                                                <span className="text-[11px] px-1.5 py-0.5 rounded bg-blue-100 text-blue-700">
                                                    Khách hàng
                                                </span>
                                            ) : item?.ticket_comment_visibility ===
                                              'public' ? (
                                                <span className="text-[11px] px-1.5 py-0.5 rounded bg-green-100 text-green-700">
                                                    Đã gửi KH
                                                </span>
                                            ) : (
                                                <span className="text-[11px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
                                                    Nội bộ
                                                </span>
                                            )}
                                        </div>
                                        <Typogaphy
                                            size="small"
                                            className="font-medium"
                                        >
                                            {item?.ticket_comment_text || ''}
                                        </Typogaphy>
                                        <Typogaphy size="small">
                                            {item?.updated_at
                                                ? dayjs(item.updated_at).format(
                                                      'DD/MM/YYYY'
                                                  )
                                                : ''}
                                        </Typogaphy>
                                    </div>

                                    {employee?.employee_id ===
                                        item?.employee_id && (
                                        <div className="flex gap-2">
                                            <IconButton
                                                size="medium"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <EditIcons className="text-blue-500" />
                                            </IconButton>
                                            <IconButton
                                                size="medium"
                                                onClick={() =>
                                                    setConfirmation({
                                                        title: t(
                                                            'ticket-comment-title'
                                                        ),
                                                        description: t(
                                                            'ticket-comment-description'
                                                        ),
                                                        onConfirm: () => {
                                                            handleDeleteComment(
                                                                item.ticket_comment_id
                                                            )
                                                        },
                                                        open: true,
                                                    })
                                                }
                                            >
                                                <DeleteOutlineIcons className="text-red-500" />
                                            </IconButton>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : null}

            {selectedImage && (
                <div
                    className="fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50"
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Full size preview"
                        className="max-w-full max-h-full"
                    />
                </div>
            )}

            {editingComment && (
                <Dialog
                    open={true}
                    onClose={() => setEditingComment(null)}
                    title={t('edit')}
                >
                    <form className="mt-2">
                        <FormItem
                            control={control}
                            name="ticket_comment_text"
                            type="textarea"
                            placeholder={t('ticket-comment-text')}
                        />
                        <div className="flex justify-end gap-2 mt-4">
                            <Button
                                size="small"
                                variant="outlined"
                                loading={isPending}
                                disabled={isPending}
                                onClick={() => setEditingComment(null)}
                            >
                                {t('cancle-operation')}
                            </Button>
                            <Button
                                size="small"
                                variant="contained"
                                type="submit"
                                loading={isPending}
                                disabled={isPending}
                                onClick={handleSubmit(handleUpdateComment)}
                            >
                                {t('updated')}
                            </Button>
                        </div>
                    </form>
                </Dialog>
            )}
        </div>
    )
}

export default TicketCommentsList
